import classNames from 'classnames'

export default function SegmentControl({
  label,
  buttons,
}: {
  label: string
  buttons: { label: string; onClick: () => void; isActive: boolean }[]
}) {
  return (
    <div className="flex items-center">
      {/* Label is context the segments mostly carry on their own; hide it below
          md to save width/rows in the cramped mobile chart header. */}
      <span className="mr-2 hidden text-ui-xs text-default md:inline">{label}</span>
      <span className="isolate inline-flex space-x-0.5 rounded-md border border-transparent bg-surface-strong px-[3px] py-[3px]">
        {buttons?.map((button) => (
          <button
            key={button.label}
            onClick={() => button.onClick()}
            type="button"
            className={classNames(
              `relative inline-flex items-center rounded-sm px-2.5 py-1 text-ui-xs text-strong focus:z-10 focus:outline-none md:px-4`,
              button.isActive ? `bg-surface shadow-elevation-1` : `bg-surface-strong hover:bg-surface-muted`,
            )}
          >
            <span>{button.label}</span>
          </button>
        ))}
      </span>
    </div>
  )
}
